/**
 * CDS reports a field in its own notation - `declaration.goodsShipment.governmentAgencyGoodsItem.1.additionalDocument.1.additionalDocument_id.`
 * - numbering arrays from one. This turns it into the form's path, numbering arrays from zero:
 * `goodsShipment.governmentAgencyGoodsItem.0.additionalDocument.0.id`.
 */
const transformCdsErrorField = (field: string | null | undefined) => {
    if (field == null) return null;

    const segments = field.split('.');

    segments.pop(); // the field ends in a dot so we remove the empty string at the end

    const fieldPaths: string[] = [];

    for (const segment of segments) {
        if (segment === 'declaration') continue;

        // `additionalDocument_id` is the form's `id`
        const name = segment.split('_').at(-1) as string;

        // Array positions count from one in CDS and from zero in the form
        const position = Number(name);
        const isPosition = Number.isInteger(position) && position > 0;

        fieldPaths.push(isPosition ? String(position - 1) : name);
    }

    return fieldPaths.join('.');
};

export default transformCdsErrorField;
